<template>
  <dialog-base
    :visible.sync="visible"
    title="Chỉnh sửa khoản thu học sinh"
    size="lg"
    :use-panel="false"
    top="6vh"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-width="170px"
      label-position="left"
      class="sk-dialog-content"
      v-loading="loadingData"
    >
      <!-- PHÂN KHU 1 – THÔNG TIN CHUNG (read-only) -->
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-user" /></div>
          <div>
            <p class="sk-panel-title">Thông tin học sinh & Phiếu thu</p>
            <p class="sk-panel-subtitle">Chi tiết thông tin phiếu thu (không thể chỉnh sửa)</p>
          </div>
        </div>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Họ tên" label-width="70px" class="mb-2">
              <div class="cmd-readonly">{{ dataForm.fullName || "-" }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tháng - Năm" label-width="120px" class="mb-2">
              <div class="cmd-readonly">
                <span v-if="dataForm.month && dataForm.year">Tháng {{ dataForm.month }}/{{ dataForm.year }}</span>
                <span v-else>-</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Đợt thu" label-width="70px" class="mb-0">
              <div class="cmd-readonly">
                <span v-if="dataForm.turn">Đợt {{ dataForm.turn }}</span>
                <span v-else>-</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mã khoản thu" label-width="120px" class="mb-0">
              <div class="cmd-readonly">{{ dataForm.revenueCode || "-" }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- PHÂN KHU 2 – THÔNG TIN KHOẢN THU (editable) -->
      <div class="sk-panel mb-4">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-edit-outline" /></div>
          <div>
            <p class="sk-panel-title">Chỉnh sửa chi tiết khoản thu chính</p>
            <p class="sk-panel-subtitle">Chỉnh sửa tên khoản thu, đơn giá, số lượng, giảm giá và mô tả</p>
          </div>
        </div>

        <el-row :gutter="20">
          <!-- Tên khoản thu -->
          <el-col :span="12">
            <el-form-item label="Tên khoản thu" prop="revenueName">
              <el-input disabled v-model="dataForm.revenueName" placeholder="Nhập tên khoản thu" />
            </el-form-item>
          </el-col>

          <!-- Đơn vị tính -->
          <el-col :span="12">
            <el-form-item label="Đơn vị tính" prop="unit">
              <el-select
                v-model="dataForm.unit"
                filterable
                allow-create
                default-first-option
                placeholder="Chọn hoặc nhập đơn vị"
                style="width: 100%;"
              >
                <el-option v-for="u in unitsList" :key="u" :label="u" :value="u" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Đơn giá -->
          <el-col :span="12">
            <el-form-item label="Đơn giá (VNĐ)" prop="price">
              <el-currency-input
                v-model="dataForm.price"
                :options="currencyOptions"
                :disabled="isParentReadOnly"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <!-- Số lượng -->
          <el-col :span="12">
            <el-form-item label="Số lượng" prop="quantity">
              <el-input
                v-model.number="dataForm.quantity"
                type="number"
                :step="allowDecimal ? 0.01 : 1"
                :disabled="isParentReadOnly"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Cho phép số thập phân">
              <el-switch
                :value="allowDecimal"
                active-text="Có"
                inactive-text="Không"
                @change="handleAllowDecimalChange"
              />
            </el-form-item>
          </el-col>

          <!-- Giảm giá Có / Không -->
          <el-col :span="12">
            <el-form-item label="Giảm giá" prop="discount">
              <el-radio-group v-model="dataForm.discount" @change="handleDiscountToggle">
                <el-radio :label="true">Có</el-radio>
                <el-radio :label="false">Không</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- Thành tiền -->
          <el-col :span="12">
            <el-form-item label="Thành tiền (VNĐ)" prop="amount">
              <el-currency-input
                v-model="displayAmount"
                :options="currencyOptions"
                disabled
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>

          <!-- Thuế suất -->
          <el-col :span="12">
            <el-form-item label="Thuế suất" prop="taxPercentage">
              <el-select
                v-model="dataForm.taxPercentage"
                placeholder="Chọn thuế suất"
                clearable
                style="width: 100%;"
                @change="handleTaxChange"
              >
                <el-option label="Không chịu thuế" :value="-2" />
                <el-option label="Không kê khai" :value="-1" />
                <el-option label="0%" :value="0" />
                <el-option label="5%" :value="5" />
                <el-option label="8%" :value="8" />
                <el-option label="10%" :value="10" />
                <el-option label="Khác" value="other" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Thuế khác (%) nếu chọn Khác -->
          <el-col :span="12" v-if="String(dataForm.taxPercentage) === 'other'">
            <el-form-item label="Thuế khác (%)" prop="taxPercentageInput">
              <el-input-number
                v-model="dataForm.taxPercentageInput"
                :controls="false"
                :min="0"
                :max="100"
                style="width: 100%;"
                placeholder="Nhập % thuế"
              />
            </el-form-item>
          </el-col>

          <!-- Loại giảm giá -->
          <el-col :span="12" v-if="dataForm.discount">
            <el-form-item label="Loại giảm giá" prop="discountType">
              <el-select
                v-model="dataForm.discountType"
                placeholder="Chọn loại giảm giá"
                style="width: 100%;"
                @change="handleDiscountTypeChange"
              >
                <el-option label="Phần trăm (%)" value="PERCENT" />
                <el-option label="Số tiền (VNĐ)" value="MONEY" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Giá trị giảm -->
          <el-col :span="12" v-if="dataForm.discount">
            <el-form-item prop="discountValue">
              <template v-slot:label>
                <span v-if="dataForm.discountType === 'PERCENT'">Phần trăm giảm (%)</span>
                <span v-else>Số tiền giảm (VNĐ)</span>
              </template>
              <div class="edit-discount-container">
                <div class="edit-discount-input">
                  <template v-if="dataForm.discountType === 'MONEY'">
                    <el-currency-input
                      v-model="dataForm.discountValue"
                      :options="currencyOptions"
                      style="width: 100%;"
                    />
                  </template>
                  <template v-else>
                    <el-input-number v-discount-percent
                      v-model="dataForm.discountValue"
                      :min="0"
                      :max="100"
                      :precision="0"
                      controls-position="right"
                      style="width: 100%;"
                    />
                  </template>
                </div>
                <div v-if="discountAmount > 0" class="erd-discount-amount">
                  -{{ formatMoney(discountAmount) }}
                </div>
              </div>
            </el-form-item>
          </el-col>

          <!-- Mô tả -->
          <el-col :span="24">
            <el-form-item label="Mô tả" prop="description">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="Nhập mô tả..."
                v-model="dataForm.description">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- PHÂN KHU 2.1 – THÔNG TIN CÔNG THỨC (chỉ hiển thị khi có công thức) -->
      <div v-if="dataForm.calculationType === 'FORMULA'" class="sk-panel mb-4 eid-formula-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-s-operation" /></div>
          <div>
            <p class="sk-panel-title">Công thức tính</p>
            <p class="sk-panel-subtitle">Đơn giá khoản chính được tính tự động từ công thức dưới đây</p>
          </div>
        </div>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="Biểu thức" label-width="100px" class="mb-2">
              <div class="eid-formula-expr">{{ dataForm.formulaExpression }}</div>
            </el-form-item>
          </el-col>
          <el-col v-if="dataForm.formulaExpressionName" :span="24">
            <el-form-item label="Diễn giải" label-width="100px" class="mb-0">
              <div class="eid-formula-name">{{ dataForm.formulaExpressionName }}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- PHÂN KHU 2.1b – THÔNG TIN SUM_BLOCKS (đón muộn) -->
      <div v-if="dataForm.calculationType === 'SUM_BLOCKS'" class="sk-panel mb-4 eid-formula-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-time" /></div>
          <div>
            <p class="sk-panel-title">Tính theo khung giờ</p>
            <p class="sk-panel-subtitle">Đơn giá và số lượng khoản chính được tổng hợp tự động từ các khung giờ bên dưới</p>
          </div>
        </div>
      </div>

      <!-- PHÂN KHU 2.2 – CÁC KHOẢN THU CON (editable) -->
      <template v-if="dataForm.invoiceDetailItems && dataForm.invoiceDetailItems.length > 0">
        <el-collapse v-model="activeChildPanels" class="mb-4 sk-child-collapse">
          <el-collapse-item 
            v-for="(child, index) in dataForm.invoiceDetailItems" 
            :key="child.idx || index"
            :name="child.idx || String(index)"
            class="sk-panel"
          >
            <template slot="title">
              <div class="sk-panel-head child-panel-head">
                <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-edit-outline" /></div>
                <div>
                  <p class="sk-panel-title">
                    <span v-if="child.alias" class="eid-alias-badge">{{ child.alias }}</span>
                    <span v-if="dataForm.calculationType === 'SUM_BLOCKS'">{{ child.revenueName }}</span>
                    <span v-else>Khoản phụ: {{ child.revenueName }}</span>
                  </p>
                  <p class="sk-panel-subtitle">Thành tiền: {{ formatMoney(getCalculatedAmount(child)) }}</p>
                </div>
              </div>
            </template>
            
            <div class="child-panel-body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Tên khoản thu" :prop="'invoiceDetailItems.' + index + '.revenueName'">
                    <el-input disabled v-model="child.revenueName" />
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="Đơn vị tính" :prop="'invoiceDetailItems.' + index + '.unit'">
                    <el-select
                      v-model="child.unit"
                      filterable
                      allow-create
                      default-first-option
                      placeholder="Chọn hoặc nhập đơn vị"
                      style="width: 100%;"
                      @change="(val) => handleChildUnitChange(val)"
                    >
                      <el-option v-for="u in unitsList" :key="u" :label="u" :value="u" />
                    </el-select>
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="Đơn giá (VNĐ)" :prop="'invoiceDetailItems.' + index + '.price'"
                    :rules="[{ validator: validateChildPrice, trigger: 'blur' }]">
                    <el-currency-input v-model="child.price" :options="currencyOptions" style="width: 100%;" />
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="Số lượng" :prop="'invoiceDetailItems.' + index + '.quantity'"
                    :rules="childQuantityRules">
                    <el-input
                      v-model.number="child.quantity"
                      type="number"
                      :step="allowDecimal ? 0.01 : 1"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="Giảm giá" :prop="'invoiceDetailItems.' + index + '.discount'">
                    <el-radio-group v-model="child.discount" :disabled="dataForm.calculationType === 'SUM_BLOCKS'" @change="(val) => handleChildDiscountToggle(val, child)">
                      <el-radio :label="true">Có</el-radio>
                      <el-radio :label="false">Không</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="Thành tiền (VNĐ)" :prop="'invoiceDetailItems.' + index + '.amount'">
                    <el-currency-input :value="getCalculatedAmount(child)" :options="currencyOptions" disabled style="width: 100%;" />
                  </el-form-item>
                </el-col>
                
                <el-col :span="12" v-if="child.discount">
                  <el-form-item label="Loại giảm giá" :prop="'invoiceDetailItems.' + index + '.discountType'"
                    :rules="[{ validator: (r,v,c) => validateChildDiscountType(r,v,c,child), trigger: 'change' }]">
                    <el-select v-model="child.discountType" placeholder="Chọn loại giảm giá" style="width: 100%;" @change="() => handleChildDiscountTypeChange(child)">
                      <el-option label="Phần trăm (%)" value="PERCENT" />
                      <el-option label="Số tiền (VNĐ)" value="MONEY" />
                    </el-select>
                  </el-form-item>
                </el-col>
                
                <el-col :span="12" v-if="child.discount">
                  <el-form-item :prop="'invoiceDetailItems.' + index + '.discountValue'"
                    :rules="[{ validator: (r,v,c) => validateChildDiscountValue(r,v,c,child), trigger: 'blur' }]">
                    <template v-slot:label>
                      <span v-if="child.discountType === 'PERCENT'">Phần trăm giảm (%)</span>
                      <span v-else>Số tiền giảm (VNĐ)</span>
                    </template>
                    <div class="edit-discount-container">
                      <div class="edit-discount-input">
                        <template v-if="child.discountType === 'MONEY'">
                          <el-currency-input v-model="child.discountValue" :options="currencyOptions" style="width: 100%;" />
                        </template>
                        <template v-else>
                          <el-input-number v-discount-percent v-model="child.discountValue" :min="0" :max="100" :precision="0" controls-position="right" style="width: 100%;" />
                        </template>
                      </div>
                      <div v-if="getDiscountAmount(child) > 0" class="erd-discount-amount">
                        -{{ formatMoney(getDiscountAmount(child)) }}
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                
                <el-col :span="24">
                  <el-form-item label="Mô tả" :prop="'invoiceDetailItems.' + index + '.description'">
                    <el-input type="textarea" :rows="2" placeholder="Nhập mô tả..." v-model="child.description"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-collapse-item>
        </el-collapse>
      </template>

      <!-- PHÂN KHU 3 – HÓA ĐƠN ĐIỆN TỬ -->
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon sk-panel-icon--warning"><i class="el-icon-tickets" /></div>
          <div>
            <p class="sk-panel-title">Hóa đơn điện tử</p>
            <p class="sk-panel-subtitle">Cấu hình xuất hóa đơn điện tử cho khoản thu này</p>
          </div>
        </div>

        <el-form-item label="Xuất hóa đơn điện tử" prop="issuingElectronicInvoices">
          <el-radio-group v-model="dataForm.issuingElectronicInvoices">
            <el-radio :label="true">Có</el-radio>
            <el-radio :label="false">Không</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" type="danger" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="loading" :disabled="loadingData" @click="handleSubmit">Lưu</el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import { discountPercentInput, hasOverLimitPercentDiscount, DISCOUNT_PERCENT_LIMIT_MESSAGE } from "@/utils/discountPercent";
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {DEFAULT_UNITS} from "@/constant/tuitionConstant";
import {
  hasFractionalQuantityInTree,
  isQuantityPrecisionValid,
  sumQuantityValues,
  toQuantityJsonNumber,
} from "@/components/tutition_v3/utils/quantity";

function initDataForm() {
  return {
    invoiceIdx: "",
    detailIdx: "",
    fullName: "",
    month: null,
    year: null,
    turn: null,
    revenueCode: "",
    revenueName: "",
    unit: "",
    price: 0,
    quantity: 1,
    discount: false,
    discountType: "MONEY",
    discountValue: 0,
    amount: null,
    description: "",
    invoiceDetailItems: [],
    issuingElectronicInvoices: false,
    taxPercentage: null,
    taxPercentageInput: null,
    // Formula-related fields
    hasFormula: false,
    calculationType: null,
    formulaExpression: null,
    formulaExpressionName: null,
    formulaMappings: [],
  };
}

export default {
  directives: { discountPercent: discountPercentInput },
  name: "EditInvoiceDetailItemDialog",
  components: { DialogBase },
  data() {
    const numberValidator = (fieldLabel) => (rule, value, callback) => {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        callback(new Error(`${fieldLabel} không hợp lệ`));
        return;
      }
      callback();
    };

    const validateDiscountType = (rule, value, callback) => {
      if (this.dataForm.discount && !value) {
        callback(new Error("Vui lòng chọn loại giảm giá"));
      } else {
        callback();
      }
    };

    const validateDiscountValue = (rule, value, callback) => {
      if (!this.dataForm.discount) return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập giá trị giảm"));
      }
      if (this.dataForm.discountType === "PERCENT") {
        const v = Number(value) || 0;
        if (v < 0 || v > 100) return callback(new Error("Phần trăm giảm phải trong khoảng 0–100"));
      }
      callback();
    };

    const validateQuantity = (rule, value, callback) => {
      if (!isQuantityPrecisionValid(value, this.allowDecimal)) {
        callback(new Error(this.allowDecimal
          ? "Số lượng chỉ được có tối đa 2 chữ số thập phân"
          : "Số lượng phải là số nguyên"));
        return;
      }
      callback();
    };

    const validateTaxPercentageInput = (rule, value, callback) => {
      if (String(this.dataForm.taxPercentage) !== "other") return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập thuế suất (%)"));
      }
      const num = Number(value);
      if (isNaN(num) || num < 0 || num > 100) {
        return callback(new Error("Thuế suất phải từ 0 đến 100%"));
      }
      callback();
    };

    return {
      visible: false,
      loading: false,
      loadingData: false,
      allowDecimal: false,
      activeChildPanels: [],
      unitsList: [...DEFAULT_UNITS],
      autoCalculateAmount: true,
      currencyOptions: {
        currency: "VND",
        locale: "vi",
        precision: 0,
        allowNegative: true,
      },
      dataForm: initDataForm(),
      formRules: {
        revenueName: [
          { required: true, message: "Vui lòng nhập tên khoản thu", trigger: "blur" },
        ],
        price: [{ validator: numberValidator("Đơn giá"), trigger: "blur" }],
        quantity: [
          { required: true, message: "Vui lòng nhập số lượng", trigger: "blur" },
          { validator: validateQuantity, trigger: ["blur", "change"] },
        ],
        discountType: [{ validator: validateDiscountType, trigger: "change" }],
        discountValue: [{ validator: validateDiscountValue, trigger: "blur" }],
        taxPercentageInput: [{ validator: validateTaxPercentageInput, trigger: ["blur", "change"] }],
      },
      childQuantityRules: [
        { required: true, message: "Vui lòng nhập số lượng", trigger: "blur" },
        { validator: validateQuantity, trigger: ["blur", "change"] },
      ],
    };
  },
  computed: {
    /** Whether parent price/quantity should be read-only (auto-calculated from children) */
    isParentReadOnly() {
      return this.dataForm.calculationType === 'FORMULA' || this.dataForm.calculationType === 'SUM_BLOCKS';
    },

    discountAmount() {
      if (!this.dataForm.discount) return 0;
      const price = Number(this.dataForm.price) || 0;
      const quantity = Number(this.dataForm.quantity) || 0;
      const val = Number(this.dataForm.discountValue) || 0;
      if (this.dataForm.discountType === "PERCENT") {
        return Math.round((price * quantity * val) / 100);
      }
      return val;
    },
    effectiveTaxRate() {
      if (String(this.dataForm.taxPercentage) === "other") {
        return Number(this.dataForm.taxPercentageInput) || 0;
      }
      const tax = Number(this.dataForm.taxPercentage);
      return tax > 0 ? tax : 0;
    },

    calculatedAmount() {
      const price = Number(this.dataForm.price) || 0;
      const quantity = Number(this.dataForm.quantity) || 0;
      const amountBeforeTax = (price * quantity) - this.discountAmount;
      if (this.effectiveTaxRate > 0) {
        return Math.round(amountBeforeTax * (1 + this.effectiveTaxRate / 100));
      }
      return amountBeforeTax;
    },
    displayAmount: {
      get() {
        if (this.autoCalculateAmount) {
          return this.calculatedAmount;
        }
        return this.dataForm.amount;
      },
      set(val) {
        if (!this.autoCalculateAmount) {
          this.dataForm.amount = val;
        }
      },
    },
  },
  watch: {
    "dataForm.unit"(val) {
      if (val && !this.unitsList.includes(val)) this.unitsList.push(val);
    },
    // Recalculate parent price when children change (for FORMULA and SUM_BLOCKS)
    "dataForm.invoiceDetailItems": {
      deep: true,
      handler() {
        if (this.loadingData) return;
        this.recalculateParentFromChildren();
      },
    },
  },
  methods: {
    async open(invoiceIdx, detailIdx, localDetail = {}) {
      this.visible = true;
      this.loadingData = true;
      this.allowDecimal = false;
      this.dataForm = initDataForm();
      this.activeChildPanels = [];
      this.autoCalculateAmount = true;

      try {
        const response = await ManagingStudentInvoiceService.getInvoiceDetailItem(
          invoiceIdx,
          detailIdx
        );
        const data = response?.data?.data;
        if (data) {
          const fetchedDiscount = data.discount ?? false;
          const fetchedDiscountType = data.discountType || "MONEY";
          const fetchedDiscountNumber = Number(data.discountNumber) || 0;
          
          const childList = (data.invoiceDetailItems && data.invoiceDetailItems.length > 0)
                            ? data.invoiceDetailItems
                            : (localDetail.invoiceDetailItems || []);

          let mappedTaxPercentage = null;
          let mappedTaxPercentageInput = null;
          const rawTaxVal = data.taxPercentage !== undefined && data.taxPercentage !== null ? data.taxPercentage : localDetail.taxPercentage;
          if (rawTaxVal !== null && rawTaxVal !== undefined && rawTaxVal !== "") {
            const rawTax = Number(rawTaxVal);
            if ([-2, -1, 0, 5, 8, 10].includes(rawTax)) {
              mappedTaxPercentage = rawTax;
            } else if (!isNaN(rawTax)) {
              mappedTaxPercentage = "other";
              mappedTaxPercentageInput = rawTax;
            }
          }

          this.dataForm = {
            invoiceIdx: data.invoiceIdx || invoiceIdx,
            detailIdx: data.idx || detailIdx,
            fullName: data.fullName || "",
            month: data.month || null,
            year: data.year || null,
            turn: data.turn || null,
            revenueCode: data.revenueCode || "",
            revenueName: data.revenueName || "",
            unit: data.unit || localDetail.unit || "",
            price: Number(data.price) || 0,
            quantity: data.quantity === undefined
              ? (localDetail.quantity === undefined ? 1 : localDetail.quantity)
              : data.quantity,
            discount: fetchedDiscount,
            discountType: fetchedDiscountType,
            discountValue: fetchedDiscountNumber,
            amount: data.amount !== null && data.amount !== undefined ? Number(data.amount) : null,
            description: data.description || localDetail.description || "",
            taxPercentage: mappedTaxPercentage,
            taxPercentageInput: mappedTaxPercentageInput,
            invoiceDetailItems: childList.map(child => this.mapInvoiceDetailItemForForm(child)),
            issuingElectronicInvoices: data.issuingElectronicInvoices || false,
            // Formula-related fields
            hasFormula: data.hasFormula ?? false,
            calculationType: data.calculationType || null,
            formulaExpression: data.formulaExpression || null,
            formulaExpressionName: data.formulaExpressionName || null,
            formulaMappings: data.formulaMappings || [],
          };
          this.allowDecimal = hasFractionalQuantityInTree(this.dataForm);

          if (this.dataForm.unit && !this.unitsList.includes(this.dataForm.unit)) {
            this.unitsList.push(this.dataForm.unit);
          }
          this.dataForm.invoiceDetailItems.forEach(child => {
            if (child.unit && !this.unitsList.includes(child.unit)) {
              this.unitsList.push(child.unit);
            }
          });
        } else {
          throw new Error("Không thể tải thông tin chi tiết khoản thu.");
        }
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError(
          error?.response?.data?.message || "Lấy chi tiết khoản thu thất bại."
        );
        this.handleClose();
      } finally {
        this.loadingData = false;
        this.$nextTick(() => this.$refs.dataForm?.clearValidate());
      }
    },

    handleDiscountToggle(val) {
      if (!val) {
        this.dataForm.discountValue = 0;
      }
      this.$nextTick(() => this.$refs.dataForm?.clearValidate(["discountType", "discountValue"]));
    },

    handleAllowDecimalChange(value) {
      if (!value && hasFractionalQuantityInTree(this.dataForm)) {
        NotifyMessage.leftCornerNotificationWarning(
          "Vui lòng sửa tất cả số lượng về số nguyên trước khi tắt chế độ thập phân."
        );
        return;
      }
      this.allowDecimal = value;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    handleDiscountTypeChange() {
      this.dataForm.discountValue = 0;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate(["discountValue"]));
    },

    getDiscountAmount(item) {
      if (!item.discount) return 0;
      const price = Number(item.price) || 0;
      const quantity = Number(item.quantity) || 0;
      const val = Number(item.discountValue) || 0;
      if (item.discountType === "PERCENT") {
        return (price * quantity * val) / 100;
      }
      return val;
    },

    handleTaxChange(val) {
      if (val !== "other") {
        this.dataForm.taxPercentageInput = null;
      }
      this.$nextTick(() => this.$refs.dataForm?.clearValidate(["taxPercentage", "taxPercentageInput"]));
    },

    getCalculatedAmount(item) {
      if (!item) return 0;
      const price = Number(item.price) || 0;
      const quantity = Number(item.quantity) || 0;
      const amountBeforeTax = (price * quantity) - this.getDiscountAmount(item);
      const taxRate = Number(item.taxPercentage) || 0;
      if (taxRate > 0) {
        return amountBeforeTax * (1 + taxRate / 100);
      }
      return amountBeforeTax;
    },

    handleChildDiscountToggle(val, child) {
      if (!val) child.discountValue = 0;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    handleChildUnitChange(val) {
      if (val && !this.unitsList.includes(val)) this.unitsList.push(val);
    },

    mapInvoiceDetailItemForForm(item) {
      return {
        idx: item.idx,
        alias: item.alias || null,
        revenueCode: item.revenueCode || "",
        revenueName: item.revenueName || "",
        unit: item.unit || "",
        price: Number(item.price) || 0,
        quantity: item.quantity === undefined ? null : item.quantity,
        discount: item.discount ?? false,
        discountType: item.discountType || "MONEY",
        discountValue: Number(item.discountNumber) || 0,
        amount: item.amount !== null && item.amount !== undefined ? Number(item.amount) : null,
        description: item.description || "",
        taxPercentage: item.taxPercentage || null,
        invoiceDetailItems: Array.isArray(item.invoiceDetailItems)
          ? item.invoiceDetailItems.map(child => this.mapInvoiceDetailItemForForm(child))
          : [],
      };
    },

    mapInvoiceDetailItemToPayload(item) {
      return {
        idx: item.idx,
        revenueName: item.revenueName,
        unit: item.unit,
        price: item.price,
        quantity: toQuantityJsonNumber(item.quantity),
        discount: item.discount,
        discountType: item.discount ? item.discountType : null,
        discountNumber: item.discount ? item.discountValue : null,
        amount: this.getCalculatedAmount(item),
        description: item.description,
        invoiceDetailItems: Array.isArray(item.invoiceDetailItems)
          ? item.invoiceDetailItems.map(child => this.mapInvoiceDetailItemToPayload(child))
          : [],
      };
    },

    // ─── Recalculation logic ─────────────────────────────────────

    /**
     * Recalculate parent price/quantity based on calculationType
     */
    recalculateParentFromChildren() {
      const { calculationType } = this.dataForm;
      if (calculationType === 'FORMULA') {
        this.recalculateFormulaPrice();
      } else if (calculationType === 'SUM_BLOCKS') {
        this.recalculateSumBlocksPrice();
      }
      // null → no auto-calculation, user edits directly
    },

    /**
     * FORMULA: evaluate formulaExpression with alias → child.amount mapping
     */
    recalculateFormulaPrice() {
      const { formulaExpression, formulaMappings, invoiceDetailItems } = this.dataForm;
      if (!formulaExpression || !formulaMappings || !invoiceDetailItems) return;

      // Step 1: Build alias → amount map
      const aliasValues = {};
      for (const mapping of formulaMappings) {
        const child = invoiceDetailItems.find(c => c.revenueCode === mapping.revenueCode);
        aliasValues[mapping.alias] = child ? this.getCalculatedAmount(child) : 0;
      }

      // Step 2: Replace aliases in expression (longer aliases first to avoid partial replace)
      let expression = formulaExpression;
      const sortedAliases = Object.keys(aliasValues).sort((a, b) => b.length - a.length);
      for (const alias of sortedAliases) {
        const regex = new RegExp(`\\b${alias}\\b`, 'g');
        expression = expression.replace(regex, aliasValues[alias].toString());
      }

      // Step 3: Evaluate (sanitize to only math chars)
      try {
        const sanitized = expression.replace(/[^0-9+\-*/().%\s]/g, '');
        if (!sanitized) return;
        // eslint-disable-next-line no-eval
        const result = eval(sanitized);
        if (!isNaN(result) && isFinite(result)) {
          this.dataForm.price = Math.round(result);
        }
      } catch {
        // evaluation failed — keep current price
      }
    },

    /**
     * SUM_BLOCKS: sum child amounts to derive parent price/quantity
     * (Late pickup pattern — blocks have no discount, parent has discount)
     */
    recalculateSumBlocksPrice() {
      const { invoiceDetailItems } = this.dataForm;
      if (!invoiceDetailItems || invoiceDetailItems.length === 0) return;

      // Step 1: Calculate each block amount (blocks have no discount)
      let totalAmount = 0;
      invoiceDetailItems.forEach(block => {
        const blockAmount = (Number(block.price) || 0) * (Number(block.quantity) || 0);
        totalAmount += blockAmount;
      });
      const totalQuantity = sumQuantityValues(invoiceDetailItems.map(block => block.quantity));

      // Step 2: Update parent quantity and price
      this.dataForm.quantity = totalQuantity;
      this.dataForm.price = totalQuantity > 0 ? Math.round(totalAmount / totalQuantity) : 0;
    },

    handleChildDiscountTypeChange(child) {
      child.discountValue = 0;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    validateChildPrice(rule, value, callback) {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        callback(new Error('Đơn giá không hợp lệ'));
        return;
      }
      callback();
    },

    validateChildDiscountType(rule, value, callback, child) {
      if (child.discount && !value) {
        callback(new Error("Vui lòng chọn loại giảm giá"));
      } else {
        callback();
      }
    },

    validateChildDiscountValue(rule, value, callback, child) {
      if (!child.discount) return callback();
      if (value === null || value === undefined || value === "") {
        return callback(new Error("Vui lòng nhập giá trị giảm"));
      }
      if (child.discountType === "PERCENT") {
        const v = Number(value) || 0;
        if (v < 0 || v > 100) return callback(new Error("Phần trăm giảm phải trong khoảng 0–100"));
      }
      callback();
    },

    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;

        try {
          // Ensure parent price is recalculated before submit
          this.recalculateParentFromChildren();

          const childItemsPayload = this.dataForm.invoiceDetailItems.map(child =>
            this.mapInvoiceDetailItemToPayload(child)
          );

          const taxVal = this.dataForm.taxPercentage;
          const resolvedTax =
            taxVal === "other"
              ? Number(this.dataForm.taxPercentageInput) || 0
              : taxVal !== null && taxVal !== "" && taxVal !== undefined
              ? Number(taxVal)
              : null;

          const payload = {
            invoiceIdx: this.dataForm.invoiceIdx,
            detailIdx: this.dataForm.detailIdx,
            revenueName: this.dataForm.revenueName,
            unit: this.dataForm.unit,
            price: this.dataForm.price,
            quantity: toQuantityJsonNumber(this.dataForm.quantity),
            taxPercentage: resolvedTax,
            discount: this.dataForm.discount,
            discountType: this.dataForm.discount ? this.dataForm.discountType : null,
            discountNumber: this.dataForm.discount ? this.dataForm.discountValue : null,
            amount: this.calculatedAmount,
            description: this.dataForm.description,
            invoiceDetailItems: childItemsPayload,
            issuingElectronicInvoices: this.dataForm.issuingElectronicInvoices,
          };

          if (hasOverLimitPercentDiscount(payload)) {
            NotifyMessage.leftCornerNotificationError(DISCOUNT_PERCENT_LIMIT_MESSAGE);
            return;
          }

          const response = await ManagingStudentInvoiceService.updateInvoiceDetailItem(payload);
          if (response?.data?.status === 200 || response?.data?.data === true) {
            NotifyMessage.leftCornerNotificationSuccess("Cập nhật khoản thu thành công.");
            this.$emit("saved");
            this.handleClose();
          } else {
            throw new Error(response?.data?.message || "Cập nhật khoản thu thất bại.");
          }
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
            error?.response?.data?.message || "Cập nhật khoản thu thất bại."
          );
        } finally {
          this.loading = false;
        }
      });
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === "") return "—";
      return Number(value).toLocaleString("vi-VN") + " ₫";
    },

    handleClose() {
      this.visible = false;
      this.loading = false;
      this.loadingData = false;
      this.$refs.dataForm?.resetFields();
      this.dataForm = initDataForm();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.cmd-readonly {
  padding: 7px 11px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-weight: 600;
  color: #15803d;
}

/deep/ .el-input.is-disabled .el-input__inner,
/deep/ .el-input.is-disabled input,
/deep/ input:disabled {
  color: #15803d !important;
  -webkit-text-fill-color: #15803d !important;
  font-weight: 600;
}

/deep/ .el-input-number {
  width: 100%;
}

.edit-discount-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}

.edit-discount-input {
  flex: 1;
}

.erd-discount-amount {
  color: #dc2626;
  font-weight: 700;
  white-space: nowrap;
}

.sk-child-collapse {
  border: none;
}
.sk-child-collapse /deep/ .el-collapse-item__header {
  height: auto;
  line-height: inherit;
  border-bottom: none;
  background: transparent;
  padding: 10px 0;
}
.sk-child-collapse /deep/ .el-collapse-item__wrap {
  border-bottom: none;
  background: transparent;
}
.sk-child-collapse /deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
.child-panel-head {
  border-bottom: none !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
  width: 100%;
}
.child-panel-body {
  padding-top: 16px;
  border-top: 1px dashed #e2e8f0;
}

/* Formula panel */
.eid-formula-panel {
  background: #fffbeb;
}
.eid-formula-expr {
  padding: 8px 12px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  font-family: monospace;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
  word-break: break-all;
}
.eid-formula-name {
  padding: 8px 12px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #15803d;
  word-break: break-all;
}

/* Alias badge */
.eid-alias-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 5px;
  font-weight: 700;
  font-size: 12px;
  color: #2563eb;
  margin-right: 6px;
  flex-shrink: 0;
}
</style>
